<template>
  <div
    class="mt-2"
    id="board"
  >
    <vue-good-table
      :columns="headings"
      :fixed-header="false"
      :rows="characters"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionText: 'character(s) selected',
        clearSelectionText: 'clear',
      }"
      :search-options="{
        enabled: false,
        placeholder: 'search...',
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 12,
        position: 'bottom',
        dropdownAllowAll: true,
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Characters per page',
        ofLabel: 'of',
        allLabel: 'All',
      }"
      :row-style-class="rowStyleClassFn"
      v-on:cell-click="onCellClick"
      styleClass="vgt-table bordered"
      theme="black-rhino"
    >
      <template v-slot:table-row="props">
        <confirm-dialog ref="confirmDialog"></confirm-dialog>

        <!-- combat inclusion -->
        <!-- <span v-if="props.column.field === 'combat_inclusion'">
          <a>
            Yes
          </a>
          </span> -->
        <!-- character image -->
        <span v-if="props.column.field === 'image'">
          <img
            :src="props.row['image']"
            class="bb-character-table-image"
            alt="character image"
          />
        </span>
        <span v-else-if="props.column.field === 'status_image'">
          <img
            :src="getStatusImage(props.row)"
            class="bb-character-table-icon"
            alt="character status image"
          />
        </span>
        <span v-else>{{
          formatDisplayValue(
            props.column.field,
            props.formattedRow[props.column.field],
          )
        }}</span>

        <span v-if="props.column.field === 'action_delete'">
          <img
            class="bbActionIcon bb-character-table-icon"
            :src="deleteImg"
            @click="confirmDeletion(props.row)"
            alt="delete image"
          />
        </span>

        <span
          v-if="
            props.column.field == 'action_deploy' &&
            canDeployCharacters &&
            props.row.status === 'Alive' &&
            props.row['in_combat'] != true
          "
        >
          <img
            class="bbActionIcon bb-character-table-icon"
            :src="deployImg"
            @click="confirmDeployment(props.row)"
            alt="deploy image"
          />
        </span>

        <span v-if="props.column.field === 'combat_inclusion_image'">
          <img
            :src="tickImg"
            :class="['bb-character-table-icon', isVisible(props)]"
            alt="combat inclusion image"
          />
        </span>

        <span v-if="props.column.field === 'in_combat_image'">
          <img
            :src="tickImg"
            :class="['bb-character-table-icon', isVisible(props)]"
            alt="in combat image"
          />
        </span>

        <!-- <span v-else-if="props.column.field === 'seq'">
          {{ props.row.originalIndex + 1 }}
        </span> -->
      </template>

      <!-- <template #selected-row-actions>
        <button @click="buttonClicked()" class="me-4">Action 1</button>
        <button @click="buttonClicked()" class="me-4">Action 2</button>
      </template> -->

      <!-- <template #table-actions>TOP OF TABLE </template> -->
      <template #emptystate>No characters matching criteria</template>
      <!-- <template #table-actions-bottom>BOTTOM OF TABLE </template> -->

      <!-- <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'details'">
          <button type="button" class="btn btn-primary">View Details</button>
        </span>
        <span v-else> {{ props.formattedRow[props.column.field] }} </span>
      </template> -->
    </vue-good-table>
  </div>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next'
import ConfirmDialog from './ConfirmDialog.vue'
import { mapGetters } from 'vuex'
import { inject } from 'vue'

import deleteImg from '../assets/images/bbDelete48.png'
import deployImg from '../assets/images/bbDeploy.png'
import tickImg from '../assets/images/bbTick.png'
import activeStatusImg from '../assets/images/bbStatus_Active.png'
import deadStatusImg from '../assets/images/bbInactive_Dead.png'
import retiredStatusImg from '../assets/images/bbInactive_Incapacitated.png'

import convertCharacterToCombatant from '@/helpers/convertCharacterToCombatant'
import capitaliseMultipleWords from '../helpers/capitaliseMultipleWords'

export default {
  name: 'TableCharactersComponent',
  //==================================================================
  // components
  //------------
  components: {
    VueGoodTable,
    ConfirmDialog,
  },
  //==================================================================
  // setup
  //-------
  setup() {
    const global = inject('global')
    return { global }
  },
  //==================================================================
  // props
  //-------
  props: {
    headings: {
      type: Array,
      required: true,
    },
    characters: {
      type: Array,
      required: true,
    },
    canDeployCharacters: {
      type: Boolean,
      default: false,
    },
  },
  //==================================================================
  // data
  //------
  data() {
    return {
      selectedValue: null,
      selectedColumn: null,
      selectedCharacter: null,
      characters_array: [],
      deleteImg,
      deployImg,
      tickImg,
      activeStatusImg,
      deadStatusImg,
      retiredStatusImg,
    }
  },
  // watch: {
  //   this_characters() {
  //     console.log("WATCH TABLE CHARACTERS = " + this.characters[0].int_cur)
  //   }
  // },
  //==================================================================
  // computed
  //----------
  // computed: {
  //   this_characters() {
  //     return this.characters
  //   }
  // },
  //====================================================================
  // methods
  //---------
  methods: {
    ...mapGetters('combat', {
      getCampaignPlayers: 'getCampaignPlayers',
    }),
    ...mapGetters('races', {
      getRaces: 'getRaces',
    }),
    //==================================================================
    // is visible
    //------------
    isVisible(props) {
      if (
        props.column.field == 'combat_inclusion_image' &&
        props.row['combat_inclusion'] == true
      ) {
        return 'bb-img-visible'
      } else if (
        props.column.field == 'in_combat_image' &&
        props.row['in_combat'] == true
      ) {
        return 'bb-img-visible'
      }
      return 'bb-img-hidden'
    },
    //==================================================================
    // get status image
    //------------------
    getStatusImage(row) {
      if (row.status === 'Dead') {
        return this.deadStatusImg
      }

      if (row.status === 'Retired') {
        return this.retiredStatusImg
      }

      return this.activeStatusImg
    },
    formatDisplayValue(field, value) {
      if (field === 'name' && typeof value === 'string') {
        return capitaliseMultipleWords(value)
      }

      return value
    },
    //==================================================================
    // translate combat inclusion
    //----------------------------
    translateCombatInclusion(row) {
      if (row.combat_inclusion) {
        return 'Auto'
      } else {
        return 'Manual'
      }
    },
    //==================================================================
    // translate character in combat
    //-------------------------------
    translateCharacterInCombat(row) {
      //---------------
      // get character
      //---------------
      let character = this.characters[row.originalIndex]
      //-----------------------------------------
      // check if combatant exists for character
      //-----------------------------------------
      if (character.combatant && character.combatant != '') {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    //==================================================================
    // on cell click - open character sheet
    //--------------------------------------
    onCellClick(params) {
      let parm = {
        idx: params.rowIndex,
        character: params.row,
      }
      //------------------------------------------
      // exclude delete and deploy action columns
      //------------------------------------------
      if (
        params.column.field !== 'action_delete' &&
        params.column.field !== 'action_deploy'
      ) {
        if (params.column.field === 'combat_inclusion_image') {
          this.$emit('toggle-combat-inclusion', parm)
        } else {
          this.$emit('update-character', parm)
        }
      }
    },
    // params.row - row object
    // params.column - column object
    // params.rowIndex - index of this row on the current page.
    // params.event - click event
    //==================================================================
    // colour rows
    //-------------
    rowStyleClassFn(row) {
      if (row.status && row.status !== 'Alive') {
        return 'rowStatusInactive'
      } else if (row.category == 'Enemy') {
        return 'rowEnemy'
      } else if (row.category == 'Party') {
        return 'rowParty'
      } else {
        return 'rowNeutral'
      }
    },
    //==================================================================
    // confirm deletion
    //------------------
    async confirmDeletion(row) {
      const ok = await this.$refs.confirmDialog.show({
        title: 'Delete Character',
        message: 'Confirm Deletion',
        subject: row['name'],
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
      if (ok) {
        this.$emit('delete-character', row.originalIndex)
      }
    },
    //==================================================================
    // confirm deployment
    //--------------------
    async confirmDeployment(row) {
      const ok = await this.$refs.confirmDialog.show({
        title: 'Character Deployment',
        message: 'Confirm Deployment',
        subject: row['name'],
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
      //-----------------
      // where confirmed
      //-----------------
      if (ok) {
        let character = this.characters[row.originalIndex]
        let new_combatant = convertCharacterToCombatant(character)
        if (!new_combatant) {
          return
        }
        //------------------
        // deploy character
        //------------------
        this.$emit('deploy-character', new_combatant)
      }
    },
  },
}
</script>

<style scoped>
:deep(.vgt-table th.bb-characters-col-image),
:deep(.vgt-table td.bb-characters-col-image) {
  min-width: 128px !important;
  width: 128px !important;
  max-width: 128px !important;
  text-align: center !important;
}

:deep(.vgt-table th.bb-characters-col-icon),
:deep(.vgt-table td.bb-characters-col-icon) {
  min-width: 138px !important;
  width: 138px !important;
  max-width: 138px !important;
  text-align: center !important;
}

:deep(.vgt-table th.bb-characters-col-name),
:deep(.vgt-table td.bb-characters-col-name) {
  min-width: 250px !important;
  width: 250px !important;
  text-align: left !important;
}

:deep(.vgt-table thead th) {
  padding-top: 0.45rem !important;
  padding-bottom: 0.58rem !important;
}

:deep(.vgt-table tbody td) {
  padding-top: 1.2rem !important;
  padding-bottom: 1.2rem !important;
}

:deep(.vgt-wrap__footer) {
  margin-top: 1rem !important;
  padding-top: 0.75rem !important;
  padding-bottom: 2rem !important;
  border-top: 0 !important;
  box-shadow: none !important;
  font-size: 1.8rem !important;
}

:deep(.vgt-wrap__footer *),
:deep(.vgt-wrap__footer .footer__row-count__label),
:deep(.vgt-wrap__footer .footer__row-count__select),
:deep(.vgt-wrap__footer .footer__navigation) {
  font-size: 1.8rem !important;
}

:deep(.vgt-wrap__footer .footer__navigation__page-info),
:deep(.vgt-wrap__footer .footer__navigation__page-btn),
:deep(.vgt-wrap__footer .footer__row-count__label),
:deep(.vgt-wrap__footer .footer__row-count__select) {
  font-size: 1.8rem !important;
  line-height: 1.35 !important;
}

:deep(.vgt-wrap__footer .footer__row-count__label),
:deep(.vgt-wrap__footer .footer__row-count__select),
:deep(.vgt-wrap__footer .footer__navigation__page-info) {
  color: #fff !important;
}

:deep(.vgt-wrap__footer .footer__navigation__page-btn .chevron.left:after) {
  border-right-color: var(--bb-combat-scrollbar-thumb) !important;
}

:deep(.vgt-wrap__footer .footer__navigation__page-btn .chevron.right:after) {
  border-left-color: var(--bb-combat-scrollbar-thumb) !important;
}

.bb-character-table-image {
  display: block;
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

.bb-character-table-icon {
  display: block;
  width: 72px;
  height: 72px;
  margin: 0 auto;
}

:deep(.vgt-table tr.rowStatusInactive td) {
  background-color: black !important;
  color: white !important;
}

:deep(.vgt-table tr.rowStatusInactive:hover td) {
  background-color: black !important;
}
</style>
